import * as React from "react";
import { Link } from "@/components/common/Link";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { FileText, ShieldCheck } from "lucide-react";
const candidates = [{
  firstName: "Sonia",
  lastName: "Borgiani"
}, {
  firstName: "Patrizia",
  lastName: "Casadei"
}, {
  firstName: "Federico",
  lastName: "Chiodo"
}, {
  firstName: "Fabrizio",
  lastName: "Conti"
}, {
  firstName: "Adolfo",
  lastName: "Di Balsamo"
}, {
  firstName: "Consuelo",
  lastName: "Di Giampaolo"
}, {
  firstName: "Natasja",
  lastName: "Gandolfo"
}, {
  firstName: "Massimo",
  lastName: "Labozzetta"
}, {
  firstName: "Filippo Maria",
  lastName: "Lucchetti"
}, {
  firstName: "Federica",
  lastName: "Mattei"
}, {
  firstName: "Elena",
  lastName: "Mazzoni"
}, {
  firstName: "Gianmarco",
  lastName: "Nebbiai"
}, {
  firstName: "Maria Luisa",
  lastName: "Orlando"
}, {
  firstName: "Francesca",
  lastName: "Pagnini"
}, {
  firstName: "Roberto",
  lastName: "Peduzzi"
}, {
  firstName: "Aldo",
  lastName: "Ponzo"
}, {
  firstName: "Gianluca",
  lastName: "Prestipino Giarritta"
}, {
  firstName: "Rosa Maria",
  lastName: "Ravera"
}, {
  firstName: "Valter",
  lastName: "Sartori"
}, {
  firstName: "Luca",
  lastName: "Sementelli"
}, {
  firstName: "Gabriella",
  lastName: "Sergi"
}, {
  firstName: "Alessandra",
  lastName: "Tacconi"
}, {
  firstName: "Elisa",
  lastName: "Toro"
}, {
  firstName: "Aurora",
  lastName: "Zura Puntaroni"
}];
export default function CandidatesList1() {
  return <section id="candidati-lista-1" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="mb-10 text-center">
          <h2 className="font-default text-3xl md:text-4xl font-bold text-foreground mb-4">Candidati Alleanza Verdi e Sinistra</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Elenco ufficiale dei candidati. In ottemperanza alle normative sulla trasparenza, 
            sono disponibili per la consultazione i Curriculum Vitae e i certificati del Casellario Giudiziale di ciascun candidato.
          </p>
        </div>

        <div className="rounded-md border border-border bg-card shadow-sm overflow-hidden">
          <Table>
            <TableHeader className="bg-muted/50">
              <TableRow>
                <TableHead className="w-[50px] text-center font-semibold">#</TableHead>
                <TableHead className="font-semibold">Candidato</TableHead>
                <TableHead className="text-right font-semibold">Documentazione</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {candidates.map((candidate, i) => <TableRow key={i} data-index={i} className="even:bg-muted/20 hover:bg-muted/50 transition-colors">
                  <TableCell className="text-center text-muted-foreground font-medium">
                    {i + 1}
                  </TableCell>
                  <TableCell className="font-medium text-foreground">
                    {candidate.lastName} {candidate.firstName}
                  </TableCell>
                  <TableCell className="text-right">
                    <div className="flex items-center justify-end gap-2">
                      <Button variant="outline" size="sm" asChild className="h-8 text-xs">
                        <Link to="#">
                          <FileText className="size-3.5 mr-1.5" />
                          CV
                        </Link>
                      </Button>
                      <Button variant="outline" size="sm" asChild className="h-8 text-xs">
                        <Link to="#">
                          <ShieldCheck className="size-3.5 mr-1.5" />
                          Casellario
                        </Link>
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>)}
            </TableBody>
          </Table>
        </div>

        <div className="mt-6 text-center">
          <Button variant="default" asChild>
            <Link to="/CoalitionPage">Torna alla coalizione</Link>
          </Button>
        </div>
      </div>
    </section>;
}